var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',_vm._g(_vm._b({attrs:{"box-shadow":"0","vertical":true,"value":_vm.step}},'v-stepper',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }